import {
	createFileRoute,
	Link,
	Outlet,
	useLocation,
} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/PageHeader";
import { SupportNavigation } from "./support/-components/SupportNavigation";

export const Route = createFileRoute("/_auth/app/_app/help/support")({
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();
	const { t } = useTranslation();

	// Determine active section based on current route
	const getActiveSection = () => {
		const pathname = location.pathname;
		if (pathname === "/app/help/support" || pathname === "/app/help/support/") {
			return "submit";
		}
		if (pathname.includes("/tickets")) return "tickets";
		return "submit"; // default
	};

	return (
		<div className="flex flex-col h-full bg-base-200 p-4 sm:p-6">
			{/* Mobile Back Button */}
			<Link
				to="/app/help"
				className="md:hidden flex items-center gap-2 text-primary mb-4"
			>
				<ArrowLeft className="w-4 h-4" />
				{t("common.back")}
			</Link>

			<PageHeader
				title={t("help.supportTitle")}
				description={t("help.supportDescription")}
				showBackButton={false}
			/>

			{/* Side Navigation */}
			<SupportNavigation activeTab={getActiveSection()} />

			{/* Main Content Area */}
			<div className="flex-1 overflow-auto">
				<Outlet />
			</div>
		</div>
	);
}
